var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor zoho-add-attachment" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            _vm._s(_vm.$t("auto.zohoAddAttachmentToRecordZohoModuleName"))
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type zoho module name",
                "show-attributes": false,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.module,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "module", $$v)
                },
                expression: "clone.module",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.zohoAddAttachmentToRecordRecordId"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type record id of given module",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.recordId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "recordId", $$v)
                },
                expression: "clone.recordId",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.zohoAddAttachmentToRecordFileUrl"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Attach file from URL",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.url,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "url", $$v)
                },
                expression: "clone.url",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.zohoAddAttachmentToRecordFileName"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "file name",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.filename,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "filename", $$v)
                },
                expression: "clone.filename",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }